import request from '../request';
import qs from 'qs';
// 变更手机号
const changeMobileInfo = (data) => {
    return request.get(`/api/wx/auth/changeMobileInfo?${qs.stringify(data)}`)
}
// 意见反馈
const addFeedback = function (data) {
    return request.post('/api/wx/auth/messages/addFeedback', data)
}
// 系统语言更改
const changLanguage = function (data) {
    return request.post(`/api/wx/changLanguage`, data)
}
// 退出登录
const exitLogin = function (data) {
    return request.get('/api/wx/auth/logOut', data)
}
// 对象数组
export default {
    changeMobileInfo,
    addFeedback,
    changLanguage,
    exitLogin
};